import React, { useState } from 'react';
import { Input } from '../../../../components/ui/input';
import { Textarea } from '../../../../components/ui/textarea';
import { AiButton, Field, inputCls, wordCount } from '../shared';

export const validate = (wf) => {
  if (!wf.article?.title?.trim()) return 'The article needs a title.';
  if (wordCount(wf.article?.content) < 150) return 'The article is too short to continue.';
  return null;
};

const StepEditing = ({ wf, setArticle, runAi, ai }) => {
  const a = wf.article || {};
  const [instructions, setInstructions] = useState('');
  const running = ai.running && ai.action === 'polish';

  const polish = async () => {
    await runAi('polish', { instructions }, (txt) => setArticle({ content: txt }));
  };

  return (
    <div className="space-y-6">
      <Field label="Title" required testId="edit-title-field">
        <Input value={a.title || ''} onChange={(e) => setArticle({ title: e.target.value })} className={`${inputCls} h-12 text-base`} data-testid="edit-title-input" />
      </Field>
      <Field label="Excerpt" hint="Shown on the blog listing. SEO step can suggest one." testId="edit-excerpt-field">
        <Textarea value={a.excerpt || ''} onChange={(e) => setArticle({ excerpt: e.target.value })} rows={2} className={inputCls} data-testid="edit-excerpt-input" />
      </Field>
      <Field label={`Article · ${wordCount(a.content)} words`} required testId="edit-content-field">
        <Textarea value={a.content || ''} onChange={(e) => setArticle({ content: e.target.value })} rows={30} className={`${inputCls} font-mono text-sm`} readOnly={running} data-testid="edit-content-input" />
      </Field>
      <div className="rounded-2xl border border-[var(--line-2)] p-5 space-y-3">
        <div className="text-[11px] uppercase tracking-wider text-ink-3">Optional AI polish</div>
        <Input value={instructions} onChange={(e) => setInstructions(e.target.value)} className={inputCls} placeholder="e.g. Tighten the intro, shorten section 3, keep UK spelling" data-testid="edit-polish-instructions" />
        <AiButton onClick={polish} running={running} label="Polish with AI (keeps your voice)" runningLabel="Polishing…" secondary testId="edit-polish-btn" />
      </div>
    </div>
  );
};

export default StepEditing;
